import { Svg, Path } from '@react-pdf/renderer';

const HouseIcon: React.FC<{ width?: number; height?: number }> = ({
  width = 45,
  height = 40,
}) => (
    <Svg width={width} height={height} viewBox="0 0 45 40" fill="none">
    <Path d="M36.8166 19.5623V39.5723H8.20061V19.5623L22.5172 6.76758L36.8166 19.5623Z" fill="#C1BB00"/>
    <Path d="M29.6842 6.35429V0.929896C29.6842 0.654371 29.9426 0.430507 30.425 0.258304C31.6005 -0.0856272 32.8501 -0.0856272 34.0257 0.258304C34.5253 0.430507 34.7665 0.654371 34.7665 0.929896V10.866L45 20.2855H40.9342L22.5 4.32229L4.06585 20.2855H0L22.5 0L29.6842 6.35429Z" fill="#C1BB00"/>
    </Svg>
);

export default HouseIcon;